var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConversationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.08 18.29C14.69 18.15 14.26 18.36 14.12 18.75C13.8 19.65 12.95 20.25 12 20.25H7C5.76 20.25 4.75 19.24 4.75 18V6C4.75 4.76 5.76 3.75 7 3.75H12C12.95 3.75 13.8 4.35 14.12 5.25C14.26 5.64 14.69 5.85 15.08 5.71C15.47 5.57 15.67 5.14 15.54 4.75C15.01 3.25 13.59 2.25 12 2.25H7C4.93 2.25 3.25 3.93 3.25 6V18C3.25 20.07 4.93 21.75 7 21.75H12C13.59 21.75 15.01 20.75 15.54 19.25C15.68 18.86 15.47 18.43 15.08 18.29Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 6.25H13C11.48 6.25 10.25 7.48 10.25 9V11C10.25 12.52 11.48 13.75 13 13.75H14C14.14 13.75 14.25 13.86 14.25 14V16C14.25 16.3 14.43 16.58 14.71 16.69C14.8 16.73 14.9 16.75 15 16.75C15.2 16.75 15.39 16.67 15.53 16.53L18.24 13.82C18.24 13.82 18.35 13.75 18.42 13.75H19.01C20.53 13.75 21.76 12.52 21.76 11V9C21.76 7.48 20.53 6.25 19.01 6.25H19ZM20.25 11C20.25 11.69 19.69 12.25 19 12.25H18.41C17.95 12.25 17.5 12.44 17.17 12.76L15.74 14.19V14C15.74 13.04 14.95 12.25 13.99 12.25H12.99C12.3 12.25 11.74 11.69 11.74 11V9C11.74 8.31 12.3 7.75 12.99 7.75H18.99C19.68 7.75 20.24 8.31 20.24 9V11H20.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18.75H11C11.41 18.75 11.75 18.41 11.75 18C11.75 17.59 11.41 17.25 11 17.25H8C7.59 17.25 7.25 17.59 7.25 18C7.25 18.41 7.59 18.75 8 18.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationsIcon);
export default __webpack_public_path__ + "static/media/conversations_icon.59cdfe31fd0ef70d1d909c79cc6e3ced.svg";
export { ForwardRef as ReactComponent };